import { render, staticRenderFns } from "./SealDino.vue?vue&type=template&id=ca33c5de&"
import script from "./SealDino.vue?vue&type=script&lang=js&"
export * from "./SealDino.vue?vue&type=script&lang=js&"
import style0 from "./SealDino.vue?vue&type=style&index=0&id=ca33c5de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports